export default __webpack_public_path__ + "static/media/07__o_preview_1.be2fadd7.jpg";